import { render } from "./Loader.vue?vue&type=template&id=7cada07e"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=7cada07e&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__